enum TemplateEventsEnum {
	Init = 'template.init',
	Loaded = 'template.load',
	Start = 'template.start',
	Render = 'template.render',
	Error = 'template.error',
}

export default TemplateEventsEnum;
